module.exports = __webpack_public_path__ + "static/img/h5_playback_expire.b37ca08e.png";